function getDims(el) {
    const compStyle = getComputedStyle(el, null);
    return {
        width: parseFloat(compStyle.width.replace('px', '')),
        height: parseFloat(compStyle.height.replace('px', '')),
    };
}

function sizeVideoBg() {
    const htmlEls = document.getElementsByClassName('header-background-video-wrapper');
    const els = Array.prototype.slice.call(htmlEls);

    els.forEach((container) => {
        const iframe = container.getElementsByTagName('iframe')[0];
        const containerDims = getDims(container);

        const iframeRatio = 1.77777778;
        const containerRatio = containerDims.width / containerDims.height;

        if (containerRatio < iframeRatio) {
            iframe.style.height = `${containerDims.height}px`;
            iframe.style.width = `${containerDims.height * iframeRatio}px`;
        } else {
            iframe.style.width = `${containerDims.width}px`;
            iframe.style.height = `${containerDims.width / iframeRatio}px`;
        }
    });
}
window.addEventListener('resize', sizeVideoBg);
setTimeout(sizeVideoBg, 100);
